<template>
  <v-tooltip v-model="showCopied" bottom>
    <template v-slot:activator="{on}">
      <v-icon x-small @click="copy">mdi-content-copy</v-icon>
    </template>
    <div class="text-caption">Copied to clipboard</div>
  </v-tooltip>
</template>

<script>

export default {
  name: 'CopyToClipboard',
	props: {
    contentId: {type:String,required:true}
  },
  data() {
    return {
      showCopied:false
    }
  },
  methods: {
    copy() {
      const r = document.createRange();
      r.selectNode(document.getElementById(this.contentId));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(r);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      this.showCopied = true;
      setTimeout(() => this.showCopied = false, 1000);
    }
  }
}
</script>